<!--Menu-->
<div class="MainDiv">
	<label>'{{ EventDescShort }}' is a recurring event. Do you want to open only this occurrence or the series?</label>

	<div class="RadioDiv">
		<div class="RowDiv">
			<input id="Event" name="EventOption" [(ngModel)]="EventOption" type="radio" [value]="'Event'" />
			<label for="Event">Only this occurrence</label>
		</div>

		<div class="RowDiv">
			<input id="Schedule" name="EventOption" [(ngModel)]="EventOption" type="radio" [value]="'Schedule'" />
			<label for="Schedule">Open the series</label>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onConfirm()">Ok</button>
	<button class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>
